import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import SectionGrid from "@tunnel-components/@sharded/widgets/system/home/component";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { loading, data, btnloading, errorserver } = props;

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  // const authorization: boolean = true;

  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isEmpty(data) && !Lodash.isUndefined(data) && !Lodash.isNull(data);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid loading={loading} btnloading={btnloading} error={errorserver}>
      {siteLoading && (
        <section className="tunnel-site animated fadeIn">
          <BreadCrumb
            iconSupervision={true}
            links1={Paths.PathsNamesEnums.SYSTEMSHOME}
            title={i18next.t("supervision")}
            breadText1={i18next.t("systeme")}
          />
          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="with-1-columns" id="columns">
                  <div className="formLarge">
                    {Utils.transformObjectToArray(data).map(
                      (Elem: any, index: number) => {
                        return (
                          <SectionGrid
                            Elem={Elem !== null && Elem && Elem}
                            key={index}
                          />
                        );
                      }
                    )}
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  data?: any;
  btnloading?: boolean;
  errorserver?: boolean;
  noIncidents?: boolean;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/systems/home/component.tsx